import Registry from "../registry";
import React from "react";

const url = {
  name: "URL",
  group: "Content",
  schema: (part) => ({
    type: "string",
    component: (locals) => (
      <input
        type="url"
        className="form-control"
        value={locals.value || ""}
        onChange={(e) => locals.onChange(e.target.value)}
      />
    ),
    render: ({ value }) => value,
  }),
};

Registry.register("url", url);

export default url;



// WEBPACK FOOTER //
// ./app/parts/url.js